import { Panel, PanelBody, PanelGrid, PanelGridItem, PanelHeader, PanelLink, PanelTitle } from 'components';
import { Link } from 'react-router-dom';
import { BillbackDetailHeaderData } from 'types/BillbackDetailHeaderData';
import styles from './BillbackDetailsHeader.module.scss';

type Props = {
    billbackDetailHeader: BillbackDetailHeaderData
}

export default function BillbackDetailHeader({ billbackDetailHeader }: Props) {

    return (
        <Panel className={styles.panel}>
            <PanelHeader className={styles.header}>
                <PanelLink>
                    <Link to={'/search'}>Back to Search</Link>
                </PanelLink>
                <div className={styles.heading}>
                    <PanelTitle>{billbackDetailHeader.billbackNumber} | {billbackDetailHeader.vendorId}</PanelTitle>
                </div>
            </PanelHeader>
            <PanelBody className={styles.body}>
                <PanelGrid className={styles.grid}>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Type: "}
                            value={<span>{billbackDetailHeader.type}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Date: "}
                            value={<span>{billbackDetailHeader.invoiceDate}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Claimed For: "}
                            value={<span>Payment #{billbackDetailHeader.paymentIdRef ? billbackDetailHeader.paymentIdRef : " Not Available"}</span>}
                        />
                    </div>
                </PanelGrid>
            </PanelBody>
        </Panel>
    )
}